import { makeStyles } from '@gogame/ui/styles';

import { usePlaceholderPosition } from '../hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    background: theme.palette.action.hover,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    transition: 'top .3s, left .3s, width .3s',
    top: ({ top, show }) => (show ? top : null),
    left: ({ left, show }) => (show ? left : null),
    width: ({ width, show }) => (show ? width : null),
    height: ({ height, show }) => (show ? height : null),
  },
}));

const Placeholder = () => {
  const placeholderPosition = usePlaceholderPosition();
  const { top, left, width, height } = placeholderPosition || {};
  const classes = useStyles({
    show: !!placeholderPosition,
    top,
    left,
    width,
    height,
  });

  return placeholderPosition ? <div className={classes.root} /> : null;
};

export default Placeholder;
